var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckboxGrey = function SvgCheckboxGrey(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8 16c-4.369 0-8-3.631-8-8 0-4.376 3.624-8 7.992-8C12.37 0 16 3.624 16 8c0 4.369-3.623 8-8 8m-.878-4.165c.266 0 .494-.125.658-.384l3.687-5.804c.094-.165.196-.345.196-.518 0-.368-.322-.604-.667-.604-.204 0-.408.126-.557.361l-3.349 5.38-1.592-2.054c-.196-.26-.369-.33-.596-.33a.633.633 0 0 0-.627.643c0 .18.07.353.188.51l1.968 2.416c.204.274.424.384.69.384"
  })));
};
export default SvgCheckboxGrey;